const loadImageElement = (source) => new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', reject);
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = source;
});

export const getCroppedImageBlob = async (imageSrc, croppedAreaPixels, mimeType = 'image/jpeg', quality = 0.92) => {
    if (!croppedAreaPixels) {
        throw new Error('Missing crop area');
    }

    const image = await loadImageElement(imageSrc);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = croppedAreaPixels.width;
    canvas.height = croppedAreaPixels.height;

    context.drawImage(
        image,
        croppedAreaPixels.x * scaleX,
        croppedAreaPixels.y * scaleY,
        croppedAreaPixels.width * scaleX,
        croppedAreaPixels.height * scaleY,
        0,
        0,
        canvas.width,
        canvas.height
    );

    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (!blob) {
                reject(new Error('Failed to generate cropped image'));
                return;
            }
            resolve(blob);
        }, mimeType, quality);
    });
};
